import { flow, types } from 'mobx-state-tree';
import { apiService } from '@services/apiService';
import { withAlertStore } from '@stores/alert/withAlertStore';
import { withMainStore } from '@stores/main/withMainStore';
import { withProfileStore } from '@stores/profile/withProfileStore';
import { filterReqData } from '@utils/prepareData';
import { IChangeStatus } from '@/types/common';
import { IPointFormWithExtras } from '@forms/PointForm/types';
import { IPointsListData, IPointsCategoryData, IPointCreateReq, IBusinessPointData } from './types';
import { set } from 'mobx';

const { model, maybeNull, frozen, boolean } = types;

export const PointsStore = model('PointsStore', {
  pointsList: maybeNull(frozen<IPointsListData[]>()),
  pointsCategories: maybeNull(frozen<IPointsCategoryData[]>()),
  point: maybeNull(frozen<IBusinessPointData>()),
  shouldUpdatePointsCategories: boolean,
})
  .extend(withAlertStore)
  .extend(withMainStore)
  .extend(withProfileStore)
  .views((self) => ({}))
  .actions((self) => ({
    setPointsList(data: IPointsListData[]) {
      self.pointsList = data;
      return data;
    },
    setPoint(data: IBusinessPointData) {
      self.point = data;
      return data;
    },
    setPointsCategories(data: IPointsCategoryData[] | null) {
      self.pointsCategories = data;
      self.shouldUpdatePointsCategories = false;
      return data;
    },
    setShouldUpdatePointsCategories(state: boolean) {
      self.shouldUpdatePointsCategories = state;
    },
  }))
  .actions((self) => ({
    getPointsList: flow(function* (brandId: string) {
      return yield apiService
        .get(`point-list/${brandId}`)
        .then(({ data: { data } }) => {
          return self.setPointsList(data);
        })
        .catch(self.mainStore.errorHandling);
    }),
    getPointsCategories: flow(function* () {
      return yield apiService
        .get(`point/categories`)
        .then(({ data: { data } }) => {
          return self.setPointsCategories(data);
        })
        .catch(self.mainStore.errorHandling);
    }),
    getPoint: flow(function* ({ id, status }: IChangeStatus) {
      return yield apiService
        .get(`point/show/${id}?status=${status}`)
        .then(({ data: { data } }) => {
          return self.setPoint(data);
        })
        .catch(self.mainStore.errorHandling);
    }),
    addPoint: flow(function* (data: IPointFormWithExtras) {
      const { imageFile, addressData, categories, ...filtred } = data;
      const newData: IPointCreateReq = {
        ...filtred,
        categories: categories.map(({ id }) => id).join(','),
      };
      return yield apiService
        .post('point/create', filterReqData(newData))
        .catch(self.mainStore.errorHandling);
    }),
    editPoint: flow(function* (data: IBusinessPointData & IPointFormWithExtras) {
      const { imageFile, addressData, categories, logoUrl, ...filtred } = data;
      const newData: IPointCreateReq = {
        ...filtred,
        categories: categories.map(({ id }) => id).join(','),
      };
      return yield apiService
        .patch(`point/update/${data.id}`, filterReqData(newData))
        // .then(({ data: { data: newBrand } }) => {})
        .catch(self.mainStore.errorHandling);
    }),
    changeStatus: flow(function* ({ id, status }: IChangeStatus) {
      return yield apiService
        .patch(`point/update-status/${id}`, { status })
        .then(({ data: { data } }) => {
          return self.setPoint(data);
        })
        .catch(self.mainStore.errorHandling);
    }),
  }));
